<section class="page">
  <header class="page-header">
    <div>
      <h1>Offers &amp; Campaigns</h1>
      <p>Push and email campaign history and delivery results</p>
    </div>
    <div class="header-actions">
      <a routerLink="/notifications/send" class="btn btn-primary">Send offer / campaign</a>
    </div>
  </header>

  @if (error()) {
    <div class="alert alert-error">{{ error() }}</div>
  }

  <div class="panel">
    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Channel</th>
            <th>Type</th>
            <th>Targeted</th>
            <th>Push</th>
            <th>Email</th>
            <th>Failed</th>
            <th>Status</th>
            <th>Created</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          @if (loading()) {
            <tr><td colspan="11" class="muted">Loading…</td></tr>
          } @else if (!rows().length) {
            <tr><td colspan="11" class="muted">No campaigns yet</td></tr>
          } @else {
            @for (row of rows(); track row.id) {
              <tr>
                <td>{{ row.id }}</td>
                <td>{{ row.title }}</td>
                <td>{{ row.channel || 'push' }}</td>
                <td>{{ row.type || '—' }}</td>
                <td>{{ row.total_targeted ?? 0 }}</td>
                <td>{{ row.push_sent_count ?? (row.channel === 'email' ? 0 : row.sent_count) ?? 0 }}</td>
                <td>{{ row.email_sent_count ?? 0 }}</td>
                <td>{{ row.failed_count ?? 0 }}</td>
                <td>
                  <span class="badge" [attr.data-status]="row.status">{{ row.status || '—' }}</span>
                </td>
                <td>{{ row.created_at ? (row.created_at | date: 'medium') : '—' }}</td>
                <td>
                  <button
                    class="btn btn-secondary btn-sm"
                    type="button"
                    (click)="viewCampaign(row)"
                    [disabled]="loadingDetail()"
                  >
                    {{ selectedCampaign()?.id === row.id ? 'Hide' : 'Details' }}
                  </button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>

    <div class="pager">
      <span class="muted">Page {{ page() }} of {{ totalPages() }} · {{ total() }} total</span>
      <div class="pager-actions">
        <button class="btn btn-secondary" type="button" (click)="prev()" [disabled]="page() <= 1 || loading()">
          Previous
        </button>
        <button
          class="btn btn-secondary"
          type="button"
          (click)="next()"
          [disabled]="page() >= totalPages() || loading()"
        >
          Next
        </button>
      </div>
    </div>
  </div>

  @if (selectedCampaign(); as campaign) {
    <div class="panel detail-panel">
      <h2>Campaign #{{ campaign.id }}</h2>
      <dl class="detail-grid">
        <div>
          <dt>Title</dt>
          <dd>{{ campaign.title }}</dd>
        </div>
        <div>
          <dt>Channel</dt>
          <dd>{{ campaign.channel || 'push' }}</dd>
        </div>
        <div>
          <dt>Type</dt>
          <dd>{{ campaign.type || '—' }}</dd>
        </div>
        <div>
          <dt>Status</dt>
          <dd>{{ campaign.status || '—' }}</dd>
        </div>
        <div>
          <dt>Admin</dt>
          <dd>
            @if (campaign.admin; as admin) {
              {{ admin.email || admin.id }}
            } @else {
              —
            }
          </dd>
        </div>
        <div>
          <dt>Push sent / failed / skipped</dt>
          <dd>
            {{ campaign.push_sent_count ?? 0 }}
            / {{ campaign.push_failed_count ?? 0 }}
            / {{ campaign.skipped_no_token ?? 0 }}
          </dd>
        </div>
        <div>
          <dt>Email sent / failed / skipped</dt>
          <dd>
            {{ campaign.email_sent_count ?? 0 }}
            / {{ campaign.email_failed_count ?? 0 }}
            / {{ campaign.skipped_no_email ?? 0 }}
          </dd>
        </div>
        <div class="full">
          <dt>Push body</dt>
          <dd>{{ campaign.body || '—' }}</dd>
        </div>
        <div class="full">
          <dt>Email subject</dt>
          <dd>{{ campaign.email_subject || '—' }}</dd>
        </div>
        <div class="full">
          <dt>Email body</dt>
          <dd>{{ campaign.email_body || '—' }}</dd>
        </div>
        <div class="full">
          <dt>Filters</dt>
          <dd class="mono">{{ campaign.filters || '—' }}</dd>
        </div>
        <div class="full">
          <dt>Data</dt>
          <dd class="mono">{{ campaign.data || '—' }}</dd>
        </div>
      </dl>
    </div>
  }
</section>
